import styled from "@emotion/styled";
import classNames from "classnames";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { withVar } from "themes/helpers";

const StyledSpan = styled.span`
  box-sizing: border-box;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.checkbox.backgroundColor
  };
  border: 1px solid
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.checkbox.borderColor
    };
  position: relative;
  cursor: pointer;

  svg {
    display: none;
    position: absolute;
    top: 4px;
    left: 3px;
    fill: ${withVar(DesignToken.ContentInvertPrimary)};
  }

  &.checked {
    border-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.checkbox.checked.borderColor
    };
    background-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.checkbox.checked.backgroundColor
    };
    svg {
      display: inline-block;
    }
  }

  &.disabled {
    border-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.checkbox.disabled.borderColor
    };
    background-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.checkbox.disabled.backgroundColor
    };
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
`;

export interface IProps {
  name: string;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: <T extends HTMLElement>(event: React.ChangeEvent<T> | any) => void;
  onBlur?: <T extends HTMLElement>(event?: React.FocusEvent<T>) => void;
  onFocus?: <T extends HTMLElement>(event?: React.FocusEvent<T>) => void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
}

export interface ICheckboxCustomProps {
  checked?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const Checkbox: React.FC<IProps & ICheckboxCustomProps> = props => {
  const { checked, disabled } = props;

  return (
    <StyledSpan className={classNames({ checked, disabled })}>
      <Icon inline name={IconsEnum.CheckMark} width="8px" height="6px" />
      <input type="checkbox" {...props} />
    </StyledSpan>
  );
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CheckboxFinalForm: React.FC<FieldRenderProps<any> & ICheckboxCustomProps> = ({
  input,
  ...customProps
}) => <Checkbox {...input} {...customProps} />;
